<template>
  <div
    v-if="value"
    class="z-50 flex justify-center"
    :class="[
      absolute ? 'absolute inset-0' : 'relative',
      spinnerOffsetTop ? 'items-start' : 'items-center',
      { 'min-h-[calc(100vh-72px)] sm:min-h-[calc(100vh-80px)]': fullHeight },
      { 'bg-white bg-opacity-50': background },
    ]"
    :style="preloaderStyles"
  >
    <UiSpinner :value="value" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  value?: boolean;
  absolute?: boolean;
  spinnerOffsetTop?: string | number;
  minHeight?: string | number;
  fullHeight?: boolean;
  background?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  value: false,
  absolute: false,
  spinnerOffsetTop: 0,
  minHeight: 0,
  fullHeight: true,
  background: true,
});
const preloaderStyles = computed(() => {
  const styles: Record<string, any> = {};

  if (+props.minHeight) styles['min-height'] = `${Number(props.minHeight)}px`;

  if (+props.spinnerOffsetTop)
    styles['padding-top'] = `${Number(props.spinnerOffsetTop)}px`;

  return styles;
});
</script>
